/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.InboxStatusChangeRequest) => void,
  (requestParams: vp.InboxStatusChangeRequest, bearer?: string) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostApproveApprovalTransaction({ api, bearer }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.InboxStatusChangeRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.InboxStatusChangeRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.approveTransaction(requestParams, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.InboxStatusChangeRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.InboxStatusChangeRequest, callBearer?: string) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.approveTransaction(requestParams, callBearer ?? bearer, source);
      setDataFetchingInfo(false);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostApproveApprovalTransaction);
